<!-- eslint-disable @angular-eslint/template/interactive-supports-focus -->
<!-- eslint-disable @angular-eslint/template/click-events-have-key-events -->
<div class="outbound-outer-container">
  <app-current-path></app-current-path>
  <div class="console-container">
    <div class="row m-0">
      <div class="col-5 p-0">
        <span class="action-name">Records </span
        ><span class="records"> ({{ totalRecords || 0 }} records found)</span>
      </div>

      <div class="col-7 text-end padr-0">
        <div class="search-wrap">
          <img alt="" class="search-img inline-search-icon"
               src="{{ baseHref }}/assets/images/icon-search-grey.svg" />
        
          <input
            type="text"
            [(ngModel)]="filterVal"
            class="search-box mr-3"
            placeholder="Search"
            (ngModelChange)="applyFilterByField()"
          />
          <span class="clear-x"  *ngIf="filterVal"  (click)="!loading && clearSearch()"  [class.disabled]="loading">×</span>
          <!-- <span class="clear-x" *ngIf="filterVal" (click)="filterVal=''; applyFilterByField()">×</span> -->
        </div>
        <span class="link-btn p-2" (click)="clearFilter()">Clear Filter</span>

        <!-- <button class="search-btn" (click)="applyFilterByField()"><img alt="" class="search-img"
                            src="{{baseHref}}/assets/images/icon-search.svg"></button> -->
        <span *ngIf="enableAddRecord">
          <button class="outline-btn large me-2" id="add-record" (click)="addRecord($event)">
            <img alt="" class="btn-icon" src="{{ baseHref }}/assets/images/icon-add-record.svg" />
            Add Record
          </button>
        </span>
        <span *ngIf="enableCaseCreation">
          <button class="outline-btn large" id="create-case" (click)="createCase($event)">
            <img alt="" class="btn-icon" src="{{ baseHref }}/assets/images/icon-create-case.svg" />
            Create Case
          </button>
        </span>
      </div>
    </div>

    <div class="input-wrapper">
      <div class="inpp1">
        <div class="column-hide" (click)="showHideColumns()">
          <img
            alt=""
            src="{{ baseHref }}/assets/images/icon-tab-eye.png"
            style="width: 1rem; height: 1rem; margin-top: -0.25rem"
          /><span class="hid-col">Show Hide Columns ({{ headercount.shown }}/{{ headercount.hidden }})</span>
        </div>
      </div>
    </div>
    <!-- [scrollHeight]="innerHeight + 'px'" -->
    <p-table
      [scrollable]="true"
      [columns]="cols"
      [value]="dataToDisplay"
      scrollDirection="both"
      [scrollHeight]="'calc(100vh - 300px)'"
      [style]="{ width: '100%' }"
      [tableStyle]="{ 'min-width': '100%', width: 'max-content' }"
      styleClass="p-datatable-sm"
      selectionMode="single"
      dataKey="id"
      [loading]="loading"
      (onRowSelect)="onRowSelect($event)"
      [virtualScroll]="false"
    >
      <!-- (onLazyLoad)="loadLiveStatuses($event)" -->
      <ng-template pTemplate="header" let-columns>
        <tr>
          <ng-container *ngFor="let col of cols">
            <th *ngIf="!col?.hide">
              <div>
                {{ col.label }}
                <span class="fts">
                  <span class="filter" *ngIf="col.Filterable" (click)="toggleCustomColumnFilter(col.name)">
                    <ng-container *ngIf="col.filterVals; else notSelected">
                      <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter-selected.png" />
                    </ng-container>
                    <ng-template #notSelected>
                      <img alt="" class="filter-btn" src="{{ baseHref }}/assets/images/icon-filter.png" />
                    </ng-template>
                  </span>

                  <span class="sort" (click)="sortByColumn(col)">
                    <ng-container *ngIf="col.hasOwnProperty('isAsc'); else others">
                      <ng-container *ngIf="col.isAsc; else falseBlock">
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-up.png" />
                      </ng-container>
                      <ng-template #falseBlock>
                        <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort-down.png" />
                      </ng-template>
                    </ng-container>

                    <ng-template #others>
                      <img alt="" class="sort-btn" src="{{ baseHref }}/assets/images/icon-sort.png" />
                    </ng-template>
                  </span>
                </span>
              </div>
            </th>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-rowData let-columns="columns">
        <tr [ngClass]="{ Locked: rowData.Locked == true }" [pSelectableRow]="rowData">
          <ng-container *ngFor="let col of cols">
            <td *ngIf="!col?.hide">
              <ng-container
                *ngIf="
                  col.name === 'CaseOpened' ||
                  col.name === 'RoutedOn' ||
                  col.name === 'LastCalled' ||
                  col.name === 'FollowUpDate' ||
                  col.name === 'FirstResponseDate'
                "
              >
                {{ rowData[col.name] | custdate }}
              </ng-container>
              <ng-container
                *ngIf="
                  col.name !== 'CasePriority' &&
                  col.name !== 'CaseOpened' &&
                  col.name !== 'RoutedOn' &&
                  col.name !== 'LastCalled' &&
                  col.name !== 'FollowUpDate' &&
                  col.name !== 'FirstResponseDate'
                "
              >
                {{ rowData[col.name] }}
              </ng-container>
              <ng-container *ngIf="col.name === 'CasePriority' && rowData[col.name] !== null">
                <div class="priority-bar">
                  <ng-container *ngIf="rowData[col.name].split('|')[1] === 'EFAB00'">
                    <div
                      *ngFor="let color of normalPriorityColors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-segment"
                    ></div>
                  </ng-container>
                  <ng-container *ngIf="rowData[col.name].split('|')[1] === '13AA00'">
                    <div
                      *ngFor="let color of lowPriorityColors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-segment"
                    ></div>
                  </ng-container>
                  <ng-container *ngIf="rowData[col.name].split('|')[1] === 'ff6624'">
                    <div
                      *ngFor="let color of highPriorityColors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-segment"
                    ></div>
                  </ng-container>
                  <ng-container *ngIf="rowData[col.name].split('|')[1] === 'E04300'">
                    <div
                      *ngFor="let color of criticalPriorityColors"
                      [ngStyle]="{ 'background-color': color }"
                      class="color-segment"
                    ></div>
                  </ng-container>
                </div>
              </ng-container>
            </td>
          </ng-container>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage" let-columns>
        <tr>
          <td [attr.colspan]="columns?.length">No Data Available</td>
        </tr>
      </ng-template>
      <!-- <ng-template pTemplate="loadingbody" let-columns>
        <tr *ngIf="isLoadingMore">
          <td [attr.colspan]="cols?.length" class="text-center">
            <div class="infinite-scroll-loader">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
              <p>Loading more records...</p>
            </div>
          </td>
        </tr>
      </ng-template> -->
    </p-table>
    <!-- <div *ngIf="isLoadingMore" class="infinite-scroll-loader-bottom">
      <i class="pi pi-spin pi-spinner" style="font-size: 1.5rem"></i>
      <span class="ms-2">Loading more records...</span>
    </div>
    <div *ngIf="!loading && !isLoadingMore && !hasMoreData && dataToDisplay?.length > 0" class="infinite-scroll-end">
      <span>No more records to load ({{ dataToDisplay.length }} of {{ totalRecords }} loaded)</span>
    </div> -->
    <!-- <div class="priority-bar">
      <div *ngFor="let color of colors" [ngStyle]="{ 'background-color': color }" class="color-segment"></div>
    </div> -->
  </div>
</div>
